import { render, staticRenderFns } from "./AccountEditModal.vue?vue&type=template&id=08a887d4&scoped=true"
import script from "./AccountEditModal.vue?vue&type=script&lang=js"
export * from "./AccountEditModal.vue?vue&type=script&lang=js"
import style0 from "./AccountEditModal.vue?vue&type=style&index=0&id=08a887d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a887d4",
  null
  
)

export default component.exports